import React from 'react';

function Test() {
	return <div></div>;
}

export default Test;
